import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { PdpSharedContactDealerButton } from '../PdpSharedButtons/PdpSharedContactDealerButton';
import { PdpSharedContactSupportButton } from '../PdpSharedButtons/PdpSharedContactSupportButton';
import { PdpSharedRequestHold } from '../PdpSharedButtons/PdpSharedRequestHold';
import { sellerIsHereToHelpMessage } from '../pdpMessages';

// styles
import styles from './PdpRespSidebarContact.scss';

// helpers
import get from 'lodash.get';

export const PdpRespSidebarContactComponent = props => {
    const { item, user, itemId, userId, viewer } = props;
    const { isContactSupportEnabled, isMessageCenterEnabled } = viewer;
    const pricingDisplayInfo = get(props, 'displayInfo.pricing') || null;

    if (!item || !pricingDisplayInfo) {
        return null;
    }

    let supportButton = null;
    if (isMessageCenterEnabled) {
        supportButton = (
            <PdpSharedContactDealerButton buttonType="secondary" user={user} item={item} />
        );
    } else if (isContactSupportEnabled) {
        supportButton = <PdpSharedContactSupportButton user={user} item={item} />;
    }

    return (
        supportButton && (
            <React.Fragment>
                <div className={styles.questions}>{sellerIsHereToHelpMessage}</div>

                <div className={styles.buttons}>
                    <div className={styles.requestPrice}>{supportButton}</div>

                    <PdpSharedRequestHold
                        item={item}
                        userId={userId}
                        itemId={itemId}
                        trackingLocation="pdp sidebar"
                    />
                </div>
            </React.Fragment>
        )
    );
};

PdpRespSidebarContactComponent.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    item: PropTypes.object,
    relay: PropTypes.object,
    small: PropTypes.bool,
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
};

export const PdpRespSidebarContact = createFragmentContainer(PdpRespSidebarContactComponent, {
    viewer: graphql`
        fragment PdpRespSidebarContact_viewer on Viewer {
            ... @include(if: $fetchPdp) {
                isContactSupportEnabled: isEnabledByLocale(featureName: "CONTACT_1STDIBS")
                isMessageCenterEnabled: isEnabledByLocale(featureName: "MESSAGE_CENTER")
            }
        }
    `,
    displayInfo: graphql`
        fragment PdpRespSidebarContact_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    item: graphql`
        fragment PdpRespSidebarContact_item on Item {
            isCustomizable
            ...PdpSharedRequestHold_item
            ...PdpSharedContactDealerButton_item
            ...PdpSharedMakeOfferButton_item
            ...PdpSharedContactSupportButton_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarContact_user on User {
            isVerifiedTrade
            ...PdpSharedContactDealerButton_user
            ...PdpSharedMakeOfferButton_user
            ...PdpSharedContactSupportButton_user
        }
    `,
});
